import { useId } from "react";
import { cn } from "@/lib/utils";

/** Ojent mark: open “o” ring with a warm ticket notch — hospitality + POS. */
export function OjentMark({ className, size = 36 }) {
  const uid = useId().replace(/:/g, "");
  const gradId = `ojentMarkGrad-${uid}`;
  const s = typeof size === "number" ? size : undefined;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="8" y1="4" x2="56" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF7A2E" />
          <stop offset="1" stopColor="#E85402" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill={`url(#${gradId})`} />
      <circle cx="32" cy="32" r="16" stroke="white" strokeWidth="5.5" fill="none" />
      <path
        d="M48 24.5c2.2 2.3 3.5 5.3 3.5 8.5S50.2 37.2 48 39.5"
        stroke="white"
        strokeWidth="5.5"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="32" cy="32" r="4.5" fill="white" />
    </svg>
  );
}

/**
 * Full ojent lockup: mark + wordmark.
 * @param {"light"|"dark"} variant — light = dark text; dark = white text (on charcoal panels)
 */
export default function OjentLogo({
  className,
  markSize = 36,
  showWordmark = true,
  showTagline = false,
  variant = "light",
}) {
  const word = variant === "dark" ? "text-white" : "text-[#1d1d1f]";
  const tag = variant === "dark" ? "text-white/55" : "text-[#86868b]";

  return (
    <div className={cn("flex items-center gap-2.5 min-w-0", className)} aria-label="ojent">
      <OjentMark size={markSize} />
      {showWordmark && (
        <div className="min-w-0 leading-none">
          <div
            className={cn("font-display font-extrabold tracking-tight lowercase", word)}
            style={{ fontSize: Math.max(16, markSize * 0.55) }}
          >
            ojent
          </div>
          {showTagline && (
            <div className={cn("text-[10px] tracking-[0.14em] uppercase mt-1", tag)}>
              Restaurant OS
            </div>
          )}
        </div>
      )}
    </div>
  );
}
